var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"shop-btn",style:({ backgroundImage: ("url(" + (_vm.langMap[_vm.lang].bg || _vm.enBg) + ")") }),attrs:{"lang":_vm.lang,"href":"https://shop.bekko.com/sengoku/","target":"_blank"}},[_c('img',{attrs:{"src":_vm.langMap[_vm.lang].sale || _vm.enBg1}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4759bed7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopButton.vue
// module id = null
// module chunks = 